import { FC } from 'react'
import { ELanguages } from '../../../types'
import { ICartItem } from '../../../types/store'
import { scrollIntoView } from '../../../utils'
import { useLanguageContext } from '../../../contexts/LanguageContext'

export interface AccProps {
  type: ICartItem['id']
  styles: CSSModuleClasses
}

const AdditionalInfo: FC<AccProps> = ({ type, styles }) => {
  const { t, language } = useLanguageContext()

  return (
    <div className={styles['addition-wrap']}>
      <div className={styles['additional-information']}>
        <h3 style={{ marginTop: 0 }}>
          {type.startsWith('misc')
            ? `${t('HourlyWork')}: `
            : `${t('PleaseNote')}: `}
        </h3>
        {type.startsWith('graphic') ? (
          <>
            <p>
              {t('PrintingCostsNotIncluded')}.{' '}
              {t('ICanHelpWithFindingPrintingServices')}
            </p>
            <p>{t('ColorsMayVaryInPrintedWorks')}</p>
            {language !== ELanguages.en && language !== ELanguages.fi && (
              <p>
                {t(
                  'PleaseNoteThatTheAuthorJenniinaLaineSpeaksOnlyEnglishAndFinnishSo'
                )}
              </p>
            )}
          </>
        ) : type.startsWith('react') || type.startsWith('wordpress') ? (
          <>
            <p> {t('IncludesADesignMeetingWithTheClientForWebsite')}</p>
            <p>
              {t('TextAndImageContentIsNotIncluded')}.{' '}
              <button
                className="reset link"
                onClick={() => scrollIntoView('misc-translation')}
              >
                {t('SeeTranslationServiceProduct')}
              </button>
            </p>
            <p>
              {t('WebHostingAndDomainNotIncluded')}.{' '}
              {t('ICanHelpWithFindingHosting')}
            </p>
            {type.startsWith('wordpress') && (
              <p>
                {t('WordPressPaidPluginsNotIncluded')}{' '}
                {t('TheseAreAgreedSeparately')}
              </p>
            )}
            {language !== ELanguages.en && language !== ELanguages.fi && (
              <p>
                {t(
                  'PleaseNoteThatTheAuthorJenniinaLaineSpeaksOnlyEnglishAndFinnishSo'
                )}
              </p>
            )}
          </>
        ) : type.startsWith('misc') ? (
          <>
            <p>{t('PayFor10HoursGet11')}</p>
            <p>{t('HourlyWorkCanBeUsed')}</p>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}

export default AdditionalInfo
